const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'medal/CREATE',
  EDIT: 'label/EDIT',
}

export default actions
